import React from 'react';
import { Box } from '@mui/material';
import TeamProfilePicture from './TeamProfilePicture';
import TeamCoverPhoto from './TeamCoverPhoto'; // Import TeamCoverPhoto component
import TeamCompanyLogo from './TeamCompanyLogo'; // Import TeamCompanyLogo component

const TeamProfilePhotoCoverPhotoCompanyLogo = ({
    onCroppedProfilePictureBlob,
    onDeleteProfilePicture,
    onDeleteCompanylogo,
    onDeleteCoverPhoto,
    onCroppedCoverPhotoBlob,
    onCroppedCompanyLogoBlob,
    cardLayout,
    cardDesign,
    isProfilePictureRestricted = false,
    isCoverPhotoRestricted = false,
    isCompanyLogoRestricted = false,
    canRequestChange = false,
    onRestrictionNotification,
    // Optional initial image URLs for templates
    initialProfilePictureUrl,
    initialCoverPhotoUrl,
    initialCompanyLogoUrl
}) => {

    const handleProfilePictureCrop = (blob) => {
        onCroppedProfilePictureBlob(blob);
    };

    const handleCoverPhotoCrop = (blob) => {
        onCroppedCoverPhotoBlob(blob);
    };

    const handleCompanyLogoCrop = (blob) => {
        onCroppedCompanyLogoBlob(blob);
    };

    return (
        <div>
            {/* Row for Profile Picture, Cover Photo, and Company Logo */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 2,
                    marginTop: "30px"
                }}
            >
                <TeamProfilePicture
                    onCroppedImage={handleProfilePictureCrop}
                    cardLayout={cardLayout}
                    onDeleteProfilePicture={onDeleteProfilePicture}
                    cardDesign={cardDesign}
                    isRestricted={isProfilePictureRestricted}
                    canRequestChange={canRequestChange}
                    onRestrictionNotification={onRestrictionNotification}
                    initialImageUrl={initialProfilePictureUrl}
                />
                <TeamCoverPhoto
                    onCroppedImage={handleCoverPhotoCrop}
                    onDeleteCoverPhoto={onDeleteCoverPhoto}
                    initialImageUrl={initialCoverPhotoUrl}
                    isRestricted={isCoverPhotoRestricted}
                    canRequestChange={canRequestChange}
                    onRestrictionNotification={onRestrictionNotification}
                />
                <TeamCompanyLogo
                    onCroppedImage={handleCompanyLogoCrop}
                    onDeleteCompanylogo={onDeleteCompanylogo}
                    isRestricted={isCompanyLogoRestricted}
                    canRequestChange={canRequestChange}
                    onRestrictionNotification={onRestrictionNotification}
                    initialImageUrl={initialCompanyLogoUrl}
                />

            </Box>
        </div>
    );
};

export default TeamProfilePhotoCoverPhotoCompanyLogo;